import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fas as far } from '@fortawesome/free-solid-svg-icons'
import { faFontAwesome } from '@fortawesome/free-brands-svg-icons'

import './index.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import App from './App';
import Summary from './summary';
import Articles from './articles';
import Article from './article';
import CoseVersoHemelslinn from './coseversohemelslinn';
import PillarPage from './pillarpage';
import MaurizioFeruglio from './maurizioferuglio';
import Privacy from './privacy';
import Cookies from './cookies';

import reportWebVitals from './reportWebVitals';

import './css/animate.css';
import './css/ionicons.min.css';
import './css/owl.carousel.min.css';
//import './css/modal-video.scss';
import "./css/icomoon.css";
import "./css/open-iconic-bootstrap.min.css";
import "./css/owl.theme.default.min.css";
import "./css/magnific-popup.css";
import "./css/bootstrap-datepicker.css";
import "./css/jquery.timepicker.css";
import "./css/flaticon.css";
import './css/style.css';

library.add(fas, far, faFontAwesome)

function AnalyticsPageTracker() {
	const location = useLocation();

	useEffect(() => {
		const sendPageView = () => {
			if (!window.__versoGa4Enabled || typeof window.gtag !== 'function') return;

			window.gtag('event', 'page_view', {
				page_title: document.title,
				page_location: window.location.href,
				page_path: `${location.pathname}${location.search}`
			});
		};

		sendPageView();
		window.addEventListener('verso:ga4-ready', sendPageView);
		return () => window.removeEventListener('verso:ga4-ready', sendPageView);
	}, [location.pathname, location.search]);

	return null;
}

function PreviewViewTracker() {
	const location = useLocation();

	useEffect(() => {
		let isPreviewVisible = false;
		let hasSentPreviewView = false;
		let observer;

		const sendPreviewView = () => {
			if (!isPreviewVisible || hasSentPreviewView || !window.__versoGa4Enabled || typeof window.gtag !== 'function') return;

			const source = new URLSearchParams(window.location.search);
			hasSentPreviewView = true;
			window.gtag('event', 'preview_view', {
				page_title: document.title,
				page_location: window.location.href,
				page_path: `${location.pathname}${location.search}`,
				preview_anchor: 'preview',
				campaign_source: source.get('utm_source') || '',
				campaign_medium: source.get('utm_medium') || '',
				campaign_name: source.get('utm_campaign') || '',
				content_id: source.get('utm_content') || '',
				transport_type: 'beacon'
			});
		};

		const observePreview = () => {
			const preview = document.getElementById('preview');
			if (!preview || typeof IntersectionObserver === 'undefined') return;

			observer = new IntersectionObserver((entries) => {
				isPreviewVisible = entries.some((entry) => entry.isIntersecting);
				if (isPreviewVisible) sendPreviewView();
			}, {threshold: 0.35});
			observer.observe(preview);
		};

		observePreview();
		window.addEventListener('verso:ga4-ready', sendPreviewView);
		return () => {
			window.removeEventListener('verso:ga4-ready', sendPreviewView);
			if (observer) observer.disconnect();
		};
	}, [location.pathname, location.search, location.hash]);

	return null;
}

function PreviewPdfDownload() {
	const location = useLocation();

	useEffect(() => {
		let hasRedirected = false;
		const redirectToPdf = () => {
			if (hasRedirected) return;
			hasRedirected = true;
			window.location.replace("/Verso_Hemelslinn_Anteprima_CF_v5.6.pdf");
		};

		if (window.__versoGa4Enabled && typeof window.gtag === "function") {
			const source = new URLSearchParams(location.search);
			window.gtag("event", "preview_pdf_download", {
				file_name: "Verso_Hemelslinn_Anteprima_CF_v5.6.pdf",
				page_path: `${location.pathname}${location.search}`,
				campaign_source: source.get("utm_source") || "",
				campaign_medium: source.get("utm_medium") || "",
				campaign_name: source.get("utm_campaign") || "",
				content_id: source.get("utm_content") || "",
				event_callback: redirectToPdf,
				event_timeout: 500,
				transport_type: "beacon"
			});
			window.setTimeout(redirectToPdf, 800);
		} else {
			redirectToPdf();
		}
	}, [location.pathname, location.search]);

	return null;
}

const routing = (
	<BrowserRouter>
		<AnalyticsPageTracker />
		<PreviewViewTracker />
		<Routes>
			<Route exact path="/" element={<App/>} />
			<Route path="/download/anteprima" element={<PreviewPdfDownload/>} />
			<Route path="/download/anteprima/" element={<PreviewPdfDownload/>} />
			<Route path="/fb-mau-group" element={<Navigate to="/cos-e-verso-hemelslinn/?utm_source=facebook&utm_medium=group&utm_campaign=fb-mau-group" replace />} />
			<Route path="/fb-mau-group/" element={<Navigate to="/cos-e-verso-hemelslinn/?utm_source=facebook&utm_medium=group&utm_campaign=fb-mau-group" replace />} />
			<Route path="/cos-e-verso-hemelslinn/" element={<CoseVersoHemelslinn/>} />
			<Route path="/maurizio-feruglio/" element={<MaurizioFeruglio/>} />
			<Route path="/articoli" element={<Articles/>} />
			<Route path="/articoli/:slug" element={<Article/>} />
			<Route path="/:slug" element={<PillarPage/>} />
			<Route path="/:slug/" element={<PillarPage/>} />
			<Route path="/summary" element={<Summary/>} />
			<Route path="/privacy" element={<Privacy/>} />
			<Route path="/cookie" element={<Navigate to="/cookies" replace />} />
			<Route path="/cookies" element={<Cookies/>} />
		</Routes>
	</BrowserRouter>
)

ReactDOM.render(routing, document.getElementById('root'));
/*ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
